module.exports = __webpack_public_path__ + "img/shipping_type_4.cd3449a.png";